export const OnlinePaymentKeys = {
  en: {
    'LiqPay keys': 'LiqPay keys',
    'MonoPay keys': 'MonoPay keys',
    'Create Key': 'Create Key',
    'Public key': 'Public key',
    'X token': 'X token',
    'Services using': 'Services using',
    'Cash register': 'Cash register',
    'Not selected': 'Not selected',
    'Acquiring cash register hint':
      'Receives the online payments made with this key. One per key.',
  },
  uk: {
    'LiqPay keys': 'Ключі LiqPay',
    'MonoPay keys': 'Ключі MonoPay',
    'Create Key': 'Створити ключ',
    'Public key': 'Публічний ключ',
    'X token': 'X token',
    'Services using': 'Послуг використовує',
    'Cash register': 'Каса',
    'Not selected': 'Не вибрано',
    'Acquiring cash register hint':
      'Отримує онлайн-оплати за цим ключем. Одна на ключ.',
  },
};

export const OnlinePaymentKeyForm = {
  en: {
    ...OnlinePaymentKeys.en,
    'New LiqPay key': 'New LiqPay key',
    'Edit LiqPay key': 'Edit LiqPay key',
    'Create LiqPay key': 'Create LiqPay key',
    'Update LiqPay key': 'Update LiqPay key',
    'New MonoPay key': 'New MonoPay key',
    'Edit MonoPay key': 'Edit MonoPay key',
    'Create MonoPay key': 'Create MonoPay key',
    'Update MonoPay key': 'Update MonoPay key',
    'Private key': 'Private key',
  },
  uk: {
    ...OnlinePaymentKeys.uk,
    'New LiqPay key': 'Новий ключ LiqPay',
    'Edit LiqPay key': 'Редагування ключа LiqPay',
    'Create LiqPay key': 'Створити ключ LiqPay',
    'Update LiqPay key': 'Оновити ключ LiqPay',
    'New MonoPay key': 'Новий ключ MonoPay',
    'Edit MonoPay key': 'Редагування ключа MonoPay',
    'Create MonoPay key': 'Створити ключ MonoPay',
    'Update MonoPay key': 'Оновити ключ MonoPay',
    'Private key': 'Приватний ключ',
  },
};
